module.exports = __webpack_public_path__ + "img/resources-375.5189748f.jpg";